import React from 'react';
import cx from 'classnames';
import { StyledSubTitle } from './styles';
import { getFontSize, getTitleTag } from './utils';
export const SubTitle = (props) => {
    const tag = getTitleTag(props) || 'h1';
    return (React.createElement(StyledSubTitle, { className: cx('subtitle', props.className), style: props.style, as: tag, "data-role": "subtitle", fontSize: getFontSize(tag), type: props.type }, props.children));
};
